import React, { PureComponent } from 'react';
import { DLRichTextEditor } from 'appSrc/components/UI';

export default class FormRichTextEditor extends PureComponent {
    render() {
        const { input: { value, name, onChange, onFocus, onBlur }, meta: { error, dirty } } = this.props;
        var props = {
            ...this.props,
            value,
            name,
            onChange,
            onFocus,
            onBlur,
            error: dirty ? error : undefined,
        };

        return (
            <DLRichTextEditor { ...props } />
        );
    }
}

FormRichTextEditor.defaultProps = {
    className: '',
    style: {},
};
